import { createContext, useContext } from 'react'

/**
 * Generates images id for the dom
 * @param id
 * @returns {string}
 */
export const generateImagesId = (id) => `artwork---${id}`

/**
 * @param state
 * @param action
 */
export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_IMAGE':
      return {
        ...state,
        ...action.payload,
        scrollingToImage: true
      }
    case 'SET_SCROLLING_TO_IMAGE_FALSE':
      return {
        ...state,
        scrollingToImage: false
      }
    case 'SET_SWIPE_GALLERY_OPEN':
      return {
        ...state,
        ...action.payload
      }
    case 'SET_SWIPE_GALLERY_CLOSE':
      return {
        ...state,
        ...action.payload
      }
    default:
      return { ...state }
  }
}

export const initialState = {
  /**
   * The current active image
   */
  activeImageId: 0,
  /**
   * This is used to not update the scroll position when moving between images using click instead of scroll
   */
  scrollingToImage: false,
  /**
   * Image to be shown first when swipe gallery opens
   */
  activeImageForSwipeGallery: 0,
  /**
   * DOM element as the SwipeGallery uses it to read its position
   */
  activeImageForSwipeGalleryElement: null,
  /**
   * If the gallery should open
   */
  swipeGalleryOpen: false
}

export const StateContext = createContext(initialState)

export const useImagesContext = () => useContext(StateContext)
